import alta_railway from '../assets/map_icons/alta_railway.png';
import bait from '../assets/map_icons/bait.png';
import box_van from '../assets/map_icons/box-van.png';
import camera from '../assets/map_icons/camera.png';
import chemical_incident from '../assets/map_icons/chemical-incident.png';
import clothes from '../assets/map_icons/clothes.png';
import cog from '../assets/map_icons/cog.png';
import dig from '../assets/map_icons/dig.png';
import ferry_terminals from '../assets/map_icons/ferry_terminals.png';
import hammer from '../assets/map_icons/hammer.png';
import iz from '../assets/map_icons/iz.png';
import kz_airports from '../assets/map_icons/kz_airports.png';
import kz_helicopter from '../assets/map_icons/kz_helicopter.png';
import lightbulb from '../assets/map_icons/lightbulb.png';
import minres from '../assets/map_icons/minres.png';
import pharmaceuticals from '../assets/map_icons/pharmaceuticals.png';
import sez from '../assets/map_icons/sez.png';
import telecom from '../assets/map_icons/telecom.png';
import transmission_power from '../assets/map_icons/transmission-power.png';
import azs from '../assets/map_icons/azs.png';
import sto from '../assets/map_icons/sto.png';
import warehouse from '../assets/map_icons/warehouse.png';

export const layers_dictionary = {
  total_population: 'Численность населения, человек',
  unemployment_rate: 'Уровень безработицы, %',
  vrp: 'ВРП, млн тенге',
  income: 'Доходы населения, тенге',
  inflation: 'Инфляция, %',
  count_household: 'Количество домохозяйств, ед.',
};

export const layers_colors_dictionary = {
  'Агропромышленный комплекс': '#6A5ACD',
  'Горно-металлургический комплекс': '#20B2AA',
  Туризм: '#FF7F50',
  Энергетика: '#FFD700',
  'Машиностроение и металлургия': '#DC143C',
  'Химия и нефтехимия': '#32CD32',
  'Строительные  материалы': '#1E90FF',
  'Транспорт и логистика': '#FF69B4',
  'Здравоохранение и фармацевтика': '#8B4513',
  'Прочие перспективные отрасли': '#00CED1',
  'Легкая промышленность': '#FFA500',
  'Информационно-коммуникационные технологии': '#2E8B57',
  alta_railway: '#FF4500',
  ferry_terminals: '#9932CC',
  iz: '#FF7E00',
  kz_airports: '#3CB371',
  kz_helicopter: '#0099CC',
  minres: '#4682B4',
  sez: '#6A0DAD',
  azs: '#B22222',
  sto: '#008B8B',
  warehouse: '#DA70D6',
};

export const layers_src_icons_dictionary = {
  'Агропромышленный комплекс': bait,
  'Горно-металлургический комплекс': dig,
  Туризм: camera,
  Энергетика: transmission_power,
  'Машиностроение и металлургия': cog,
  'Химия и нефтехимия': chemical_incident,
  'Строительные  материалы': hammer,
  'Транспорт и логистика': box_van,
  'Здравоохранение и фармацевтика': pharmaceuticals,
  'Прочие перспективные отрасли': lightbulb,
  'Легкая промышленность': clothes,
  'Информационно-коммуникационные технологии': telecom,
  alta_railway,
  ferry_terminals,
  iz,
  kz_airports,
  kz_helicopter,
  minres,
  sez,
  azs,
  sto,
  warehouse,
};

export const layers_icons_dictionary = {
  'Агропромышленный комплекс': 'bait',
  'Горно-металлургический комплекс': 'dig',
  Туризм: 'camera',
  Энергетика: 'transmission_power',
  'Машиностроение и металлургия': 'cog',
  'Химия и нефтехимия': 'chemical_incident',
  'Строительные  материалы': 'hammer',
  'Транспорт и логистика': 'box_van',
  'Здравоохранение и фармацевтика': 'pharmaceuticals',
  'Прочие перспективные отрасли': 'lightbulb',
  'Легкая промышленность': 'clothes',
  'Информационно-коммуникационные технологии': 'telecom',
};
